import { DGC_TYPE } from './constants.js';
/** P-UX primary balance: funds in address balance accumulator. */
export async function getCpcBalance(client, owner) {
    const bal = await client.getBalance({ owner, coinType: DGC_TYPE });
    const total = BigInt(bal.totalBalance);
    const addressBalance = BigInt(bal.fundsInAddressBalance ?? 0);
    return {
        totalMist: total,
        addressBalanceMist: addressBalance,
        coinObjectCount: Number(bal.coinObjectCount ?? 0),
        looseCoinMist: total > addressBalance ? total - addressBalance : 0n,
    };
}
